The total number of phases in the process.
